<template>
    <header>
        <!-- TODO: SOCIAL MEDIA TAG -->
        <div class="hidden bg-hijau h-12 md:flex justify-end items-center">
            <div class="text-white text-base px-10 2xl:px-96">
                <a href="https://www.facebook.com/baznassamarinda/">
                    <i class="fab fa-facebook pr-5 text-lg"></i>
                </a>
                <a href="https://www.instagram.com/baznas.samarinda/">
                    <i class="fab fa-instagram pr-5 text-lg"></i>
                </a>
                <a href="https://api.whatsapp.com/send?phone=628115546000&text=Permisi Tim Baznas, saya izin bertanya" class="bg-kuning p-1 rounded-md font-bold">Call Center<i class="fas fa-phone pl-2"></i></a>
            </div>
        </div>
        <!-- TODO: Desktop -->
        <nav class="hidden w-full h-20 md:flex items-center">
            <div class="w-full px-10 2xl:px-96 flex justify-between items-center">
                <img src="../assets/images/logo.png" alt="" class="w-20 h-20">
                <ul class="flex font-bold text-hijau">
                    <li class="px-3"><router-link :to="{name: 'home'}">Home</router-link></li>
                    <li class="px-3">

                        
                        <!-- <a x-data="{open:false}" x-on:mouseleave="open =false" href="#">Tentang Kami</a> -->
                        <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative">
                            <!-- Dropdown toggle button -->
                            <button x-on:mouseover="open = true" class="flex items-center rounded-md ">
                                <span class="font-bold">Tentang Kami</span>
                            </button>

                            <!-- Dropdown menu -->
                            <div x-show="open"
                            x-transition:enter="transition ease-out duration-300"
                            x-transition:enter-start="opacity-0 transform scale-90"
                            x-transition:enter-end="opacity-100 transform scale-100"
                            x-transition:leave="transition ease-in duration-300"
                            x-transition:leave-start="opacity-100 transform scale-100"
                            x-transition:leave-end="opacity-0 transform scale-90"
                            class="absolute right-0 w-48 py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                <router-link :to="{name: 'profil'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Profil
                                </router-link>
                                <router-link :to="{name: 'hubungiKami'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Kontak Kami
                                </router-link>
                                <a href="http://pid.baznas.go.id/peraturan/"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Perundangan
                                </a>
                                <router-link :to="{name: 'laporan'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Laporan Keuangan
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="px-3"><router-link :to="{name: 'berita.index'}">Program</router-link></li>
                    <li class="px-3">
                        <!-- <a href="#">Tentang Zakat</a> -->
                        <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative">
                            <!-- Dropdown toggle button -->
                            <button x-on:mouseover="open = true" class="flex items-center rounded-md ">
                                <span class="font-bold">Edukasi</span>
                            </button>

                            <!-- Dropdown menu -->
                            <div x-show="open"
                                x-transition:enter="transition ease-out duration-200"
                                x-transition:enter-start="opacity-0 transform scale-90"
                                x-transition:enter-end="opacity-100 transform scale-100"
                                x-transition:leave="transition ease-in duration-300"
                                x-transition:leave-start="opacity-100 transform scale-100"
                                x-transition:leave-end="opacity-0 transform scale-90"
                            class="absolute right-0 w-48 py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                <router-link v-for="zakat in zakats" :key="zakat" :to="{name: 'zakat.show', params: {slug:zakat.slug}}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    {{zakat.judul}}
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="px-3">
                        <!-- <a href="#">Layanan</a> -->
                        <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative">
                            <!-- Dropdown toggle button -->
                            <button x-on:mouseover="open = true" class="flex items-center rounded-md ">
                                <span class="font-bold">Layanan</span>
                            </button>

                            <!-- Dropdown menu -->
                            <div x-show="open"
                                x-transition:enter="transition ease-out duration-300"
                                x-transition:enter-start="opacity-0 transform scale-90"
                                x-transition:enter-end="opacity-100 transform scale-100"
                                x-transition:leave="transition ease-in duration-300"
                                x-transition:leave-start="opacity-100 transform scale-100"
                                x-transition:leave-end="opacity-0 transform scale-90"
                            class="absolute right-0 w-48 py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                <router-link :to="{name: 'kalkulator'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Kalkulator Zakat
                                </router-link>
                                <router-link :to="{name: 'rekening'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400 ">
                                    Daftar Rekening
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="px-3">
                        <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative">
                            <!-- Dropdown toggle button -->
                            <button x-on:mouseover="open = true" class="flex items-center rounded-md ">
                                <span class="font-bold">Zakat</span>
                            </button>

                            <!-- Dropdown menu -->
                            <div x-show="open"
                                x-transition:enter="transition ease-out duration-300"
                                x-transition:enter-start="opacity-0 transform scale-90"
                                x-transition:enter-end="opacity-100 transform scale-100"
                                x-transition:leave="transition ease-in duration-300"
                                x-transition:leave-start="opacity-100 transform scale-100"
                                x-transition:leave-end="opacity-0 transform scale-90"
                            class="absolute right-0 w-48 py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                <router-link :to="{name: 'category.show', params: {slug: 'zakat-maal'}}"
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Zakat Mal
                                </router-link>
                                <router-link :to="{name: 'category.show', params: {slug: 'zakat-fitrah'}}"
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Zakat Fitrah
                                </router-link>
                                <router-link :to="{name: 'category.show', params: {slug: 'infak'}}"
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Infak
                                </router-link>
                                <router-link :to="{name: 'category.show', params: {slug: 'fidyah'}}"                                
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Fidyah
                                </router-link>
                                <router-link :to="{name: 'category.show', params: {slug: 'sedekah'}}"                                
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Sedekah
                                </router-link>
                                <router-link :to="{name: 'category.show', params: {slug: 'kurban'}}"                                
                                class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400">
                                    Kurban
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="px-3"><router-link :to="{name: 'dashboard'}">Akun</router-link></li>
                </ul>
                <input type="text" @click="linkToSearch" v-model="search" @keyup="searchQuery" placeholder="Cari" class="p-2 rounded-md border-hijau border-2">
            </div>
        </nav>
        <!-- TODO: Mobile -->
        <nav class="md:hidden bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-gray-800">
            <div class="container flex flex-wrap justify-between items-center mx-auto">
                <a href="#" class="flex items-center">
                    <img src="../assets/images/logo.png" class="mr-3 h-6 sm:h-9" alt="Baznas Logo" />
                </a>
                <div class="flex items-center md:order-2">
                    <button data-collapse-toggle="mobile-menu-2" type="button" id="btnMobileMenu" class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-2" aria-expanded="true">
                    <span class="sr-only">Open main menu</span>
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                    <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                    </button>
                </div>
                <div class="hidden justify-between items-center w-full md:flex md:w-auto md:order-1 z-50 mobileMenu" id="mobile-menu-2">
                    <ul class="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium ">
                        <li>
                            <router-link :to="{name: 'home'}" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700 btnCloseMenu">Home</router-link>
                        </li>
                        <li>
                            <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative w-full">
                                <!-- Dropdown toggle button -->
                                <button x-on:mouseover="open = true" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700">
                                    <span>Tentang Kami</span>
                                </button>

                                <!-- Dropdown menu -->
                                <div x-show="open"
                                    x-transition:enter="transition ease-out duration-300"
                                    x-transition:enter-start="opacity-0 transform scale-90"
                                    x-transition:enter-end="opacity-100 transform scale-100"
                                    x-transition:leave="transition ease-in duration-300"
                                    x-transition:leave-start="opacity-100 transform scale-100"
                                    x-transition:leave-end="opacity-0 transform scale-90"
                                class="absolute right-0 w-full py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                    <router-link :to="{name: 'profil'}"
                                        class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Profil
                                    </router-link>
                                    <router-link :to="{name: 'hubungiKami'}"
                                        class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Kontak Kami
                                    </router-link>
                                    <a href="http://pid.baznas.go.id/peraturan/"
                                        class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Perundangan
                                    </a>
                                    <router-link :to="{name: 'laporan'}"
                                        class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Laporan Keuangan
                                    </router-link>
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link :to="{name: 'berita.index'}" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700">Program</router-link>
                        </li>
                        <li>
                            <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative w-full">
                                <!-- Dropdown toggle button -->
                                <button x-on:mouseover="open = true" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700">
                                    <span>Edukasi</span>
                                </button>

                                <!-- Dropdown menu -->
                                <div x-show="open"
                                    x-transition:enter="transition ease-out duration-300"
                                    x-transition:enter-start="opacity-0 transform scale-90"
                                    x-transition:enter-end="opacity-100 transform scale-100"
                                    x-transition:leave="transition ease-in duration-300"
                                    x-transition:leave-start="opacity-100 transform scale-100"
                                    x-transition:leave-end="opacity-0 transform scale-90"
                                class="absolute right-0 w-full py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                    <router-link v-for="zakat in zakats" :key="zakat" :to="{name: 'zakat.show', params: {slug:zakat.slug}}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        {{zakat.judul}}
                                    </router-link>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative w-full">
                                <!-- Dropdown toggle button -->
                                <button x-on:mouseover="open = true" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700">
                                    <span>Layanan</span>
                                </button>

                                <!-- Dropdown menu -->
                                <div x-show="open"
                                    x-transition:enter="transition ease-out duration-300"
                                    x-transition:enter-start="opacity-0 transform scale-90"
                                    x-transition:enter-end="opacity-100 transform scale-100"
                                    x-transition:leave="transition ease-in duration-300"
                                    x-transition:leave-start="opacity-100 transform scale-100"
                                    x-transition:leave-end="opacity-0 transform scale-90"
                                class="absolute right-0 w-full py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                    <router-link :to="{name: 'kalkulator'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Kalkulator Zakat
                                    </router-link>
                                    <router-link :to="{name: 'rekening'}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Daftar Rekening
                                    </router-link>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div x-data="{ open: false }" x-on:mouseleave="open = false" class="relative w-full">
                                <!-- Dropdown toggle button -->
                                <button x-on:mouseover="open = true" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700">
                                    <span>Zakat</span>
                                </button>

                                <!-- Dropdown menu -->
                                <div x-show="open"
                                    x-transition:enter="transition ease-out duration-300"
                                    x-transition:enter-start="opacity-0 transform scale-90"
                                    x-transition:enter-end="opacity-100 transform scale-100"
                                    x-transition:leave="transition ease-in duration-300"
                                    x-transition:leave-start="opacity-100 transform scale-100"
                                    x-transition:leave-end="opacity-0 transform scale-90"
                                class="absolute right-0 w-full py-2 mt-2 bg-gray-100 rounded-md shadow-xl z-10">
                                    <router-link :to="{name: 'category.show', params: {slug: 'zakat-maal'}}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Zakat Mal
                                    </router-link>
                                    <router-link :to="{name: 'category.show', params: {slug: 'zakat-fitrah'}}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Zakat Fitrah
                                    </router-link>
                                    <router-link :to="{name: 'category.show', params: {slug: 'infak'}}"
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Infak
                                    </router-link>
                                    <router-link :to="{name: 'category.show', params: {slug: 'fidyah'}}"                                
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Fidyah
                                    </router-link>
                                    <router-link :to="{name: 'category.show', params: {slug: 'sedekah'}}"                                
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Sedekah
                                    </router-link>
                                    <router-link :to="{name: 'category.show', params: {slug: 'kurban'}}"                                
                                    class="block px-4 py-2 text-sm text-hijau bg-white hover:bg-gray-400  btnCloseMenu">
                                        Kurban
                                    </router-link>
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link :to="{name: 'dashboard'}" class="block w-full text-left py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark: dark:hover:bg-gray-700 dark: md:dark:hover:bg-transparent dark:border-gray-700 btnCloseMenu">Akun</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    
    //hook vue
    import { ref, computed, onMounted } from 'vue'
    
    //hook vue router
    import { useRouter } from 'vue-router'
    
    //hook vuex
    import { useStore } from 'vuex'
    
    export default {
        mounted() {
            const btn = document.querySelector('#btnMobileMenu')
            const menu= document.querySelector('.mobileMenu')
            const btnCloseMenu = document.querySelector('.btnCloseMenu')

            btn.addEventListener('click', () => {
                menu.classList.toggle("hidden");
            })

            btnCloseMenu.addEventListener('click', ()=> {
                menu.classList.toggle("hidden");
            })
        },
        setup() {

            //router
            const router = useRouter()

            //store
            const store = useStore()

            //state seacrh
            const search = ref(null)


            //queryString
            function searchQuery() {
                store.dispatch('campaign/searchCampaign', search.value)
            }

            onMounted(() => {
                store.dispatch('zakat/getZakat')
            })

            const zakats = computed(() => {
                return store.state.zakat.zakats
            })

            //redirect to route search
            function linkToSearch() {
                router.push({
                    name: 'search'
                })
            }

            return {
                search,         // <-- state search
                linkToSearch,   // <-- method linkToSearch
                searchQuery,     // <-- method searchQuery
                zakats // <-- state zakat
            }
        }

    }
</script>

<style>

</style>